import type { ConsentCategory } from '@schibsted/sourcepoint';
import type { ConsentRegistryImpl } from './types.js';

import { ALL_CATEGORIES } from './consts.js';

export type IntegrationName =
  | 'SPP Live'
  | 'SPP Comments'
  | 'Curate'
  | 'MBL'
  | 'Youbora'
  | 'Glimr'
  | 'Braze'
  | 'BrandMetrics tracking pixel'
  | 'Sentry'
  | 'Datadog'
  | 'Unleash'
  | 'Hotjar'
  | 'Iterate'
  | 'Google Analytics';

const data: Partial<Record<IntegrationName, ConsentCategory[]>> = {
  'SPP Live': [],
  'SPP Comments': [],
  Curate: [],
  MBL: [],
  Youbora: ['CMP:analytics'],
  Glimr: ALL_CATEGORIES,
  Braze: ['CMP:marketing'],
  'BrandMetrics tracking pixel': ALL_CATEGORIES,
  Sentry: [],
  Datadog: [],
  /**
   * Being investigated. Most likely requires personalisation for any rollout
   * strategy that is based on user details, but naive non-behavioural
   * strategies can be used without consent.
   */
  Unleash: ['CMP:personalisation'],
  Hotjar: ['CMP:analytics'],
  Iterate: ALL_CATEGORIES,
  'Google Analytics': ['CMP:analytics'],
};

export const registry: ConsentRegistryImpl<IntegrationName> = {
  getConsents: async function (integrationName) {
    // fallback to require all consents to be on the safe side.
    return data[integrationName] ?? ALL_CATEGORIES;
  },
};
